/**
 * PE-2128 (AC: "Sentry captures runtime errors/performance data and is visible
 * only to TCS admins in Osprey"): surfaces a link to the Sentry dashboard for
 * error/performance monitoring. Render this only behind
 * Permission.OBSERVABILITY_ERROR_MONITORING_VIEW — granted to COLLECTIVE_SUPERADMIN
 * and COLLECTIVE_ADMIN only (TCS staff), never merchant roles — which enforces
 * the TCS-admin-only access rule.
 *
 * Sentry is org-level (one project for the whole app), so there's no per-merchant
 * scoping here — the link comes from VITE_SENTRY_DASHBOARD_URL. Mirrors the
 * Clarity surface (MerchantSessionRecordings), which is per-merchant instead.
 */
import { sentryDashboardUrl } from '../../../lib/sentryDashboard';

export default function ErrorMonitoringPanel() {
  const dashboardUrl = sentryDashboardUrl();

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="text-base font-semibold text-foreground">Error Monitoring</h2>
          <p className="text-sm text-foreground mt-1">
            View runtime errors, performance data and issue trends across the platform in
            Sentry.
          </p>
        </div>
        {dashboardUrl ? (
          <a
            href={dashboardUrl}
            target="_blank"
            rel="noreferrer noopener"
            className="shrink-0 inline-flex items-center rounded-md bg-[#28282A] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-black"
          >
            Open in Sentry
          </a>
        ) : (
          <span className="shrink-0 text-sm italic text-foreground">Not configured yet</span>
        )}
      </div>
    </div>
  );
}
